document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const productRoot = form.closest('.fc-product');
    const price = productRoot?.querySelector('[data-product-price]');
    if (!variantSelect) return;

    const showVariantMedia = (option) => {
      const mediaId = option?.dataset?.mediaId;
      const mediaIndex = option?.dataset?.mediaIndex;
      if ((!mediaId || mediaId === '') && (mediaIndex === undefined || mediaIndex === '')) return;
      const gallery = productRoot?.querySelector('[data-fc-product-gallery]');
      if (!gallery) return;

      const slides = [...gallery.querySelectorAll('[data-fc-gallery-slide]')];
      let target = null;
      if (mediaId) target = slides.find((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (!target && mediaIndex !== undefined && mediaIndex !== '') {
        target = slides.find((slide) => String(slide.dataset.mediaIndex) === String(mediaIndex));
      }
      if (!target) return;

      const targetIndex = target.dataset.mediaIndex;
      const thumb = gallery.querySelector(`[data-fc-gallery-thumb][data-media-index="${targetIndex}"]`);
      if (thumb) {
        thumb.click();
        return;
      }

      slides.forEach((slide) => {
        const active = slide === target;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      const counter = gallery.querySelector('[data-fc-gallery-current]');
      const visibleIndex = slides.indexOf(target);
      if (counter && visibleIndex >= 0) counter.textContent = String(visibleIndex + 1);
    };

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option || !option.value) return;
      // Sur les sélecteurs multi-pins, le prix du haut reste toujours un prix unitaire.
      if (price && option.dataset.price && !form.querySelector('[data-fcc-pin-multi-submit]')) price.textContent = option.dataset.price;
      showVariantMedia(option);
    });
  });
});


// FC V6 mobile drawer
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-fc-mobile-menu]');
  const opener = document.querySelector('[data-fc-menu-open]');
  const closers = document.querySelectorAll('[data-fc-menu-close]');

  if (drawer && opener) {
    let closeTimer = null;
    const headerWrap = document.querySelector('.fc-header-wrap');

    const syncDrawerOffset = () => {
      // V32 : le menu latéral doit commencer sous le header sur mobile ET sur PC.
      const headerBottom = Math.max(0, Math.round(headerWrap?.getBoundingClientRect().bottom || 0));
      drawer.style.setProperty('--fcc-mobile-menu-top', `${headerBottom}px`);
    };

    const openMenu = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      syncDrawerOffset();
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        opener.classList.add('is-menu-open');
      });
      opener.setAttribute('aria-expanded', 'true');
      opener.setAttribute('aria-label', 'Fermer le menu');
      document.body.classList.add('fc-menu-lock');
    };

    const closeMenu = () => {
      drawer.classList.remove('is-open');
      opener.classList.remove('is-menu-open');
      opener.setAttribute('aria-expanded', 'false');
      opener.setAttribute('aria-label', 'Ouvrir le menu');
      document.body.classList.remove('fc-menu-lock');

      closeTimer = setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        closeTimer = null;
      }, 260);
    };

    const toggleMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen =
        !drawer.hidden &&
        drawer.classList.contains('is-open');

      if (isOpen) closeMenu();
      else openMenu();
    };

    opener.addEventListener('click', toggleMenu);
    closers.forEach((el) => el.addEventListener('click', closeMenu));
    window.addEventListener('resize', () => {
      if (!drawer.hidden && drawer.classList.contains('is-open')) syncDrawerOffset();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) closeMenu();
    });
  }
});


// FC V11 — flocage conditionnel + quantité
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const flocageSelect = form.querySelector('[data-fc-flocage-select]');
    const flocageFields = form.querySelector('[data-fc-flocage-fields]');
    const flocageInputs = form.querySelectorAll('[data-fc-flocage-input]');

    if (flocageSelect && flocageFields) {
      const syncFlocage = () => {
        const shouldShow =
          flocageSelect.value === 'Personnalisé';

        flocageFields.hidden = !shouldShow;
        flocageFields.classList.toggle('is-visible', shouldShow);

        flocageInputs.forEach((input) => {
          input.disabled = !shouldShow;
          if (!shouldShow) input.value = '';
        });
      };

      flocageSelect.addEventListener('change', syncFlocage);
      syncFlocage();
    }

    const qty = form.querySelector('[data-fc-quantity]');
    if (qty && !qty.hasAttribute('data-fcc-auto-quantity') && !qty.hasAttribute('data-fcc-pin-multi-quantity')) {
      const input = qty.querySelector('[data-fc-qty-input]');
      const minus = qty.querySelector('[data-fc-qty-minus]');
      const plus = qty.querySelector('[data-fc-qty-plus]');

      const normalize = () => {
        const value = Math.max(1, parseInt(input.value || '1', 10));
        input.value = value;
      };

      minus?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });

      plus?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      });

      input?.addEventListener('change', normalize);
    }
  });
});


// FC V12 — progression 3+1 en direct selon la quantité sélectionnée
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-form]').forEach((form) => {
    const offer = form.closest('.fc-product__info')?.querySelector('[data-fc-offer-box]');
    const qtyInput = form.querySelector('[data-fc-qty-input]');
    if (!offer || !qtyInput) return;

    const baseCartCount = parseInt(offer.dataset.cartCount || '0', 10);

    const bar = offer.querySelector('.fc-product-offer__bar');
    const message = offer.querySelector('.fc-product-offer__message');
    const countBadge = offer.querySelector('.fc-product-offer__count');
    const step1 = offer.querySelector('.fc-product-offer__step--1');
    const step2 = offer.querySelector('.fc-product-offer__step--2');
    const step3 = offer.querySelector('.fc-product-offer__step--3');
    const gift = offer.querySelector('.fc-product-offer__gift');

    const render = () => {
      const selectedQty = Math.max(1, parseInt(qtyInput.value || '1', 10));
      const projectedTotal = baseCartCount + selectedQty;
      const cycle = projectedTotal % 4;

      let progress = 0;
      let text = '';
      let unlocked = false;

      if (projectedTotal === 0) {
        progress = 0;
        text = 'Ajoutez votre premier maillot pour commencer.';
      } else if (cycle === 1) {
        progress = 0;
        text = 'Plus que 2 maillots avant de débloquer votre cadeau.';
      } else if (cycle === 2) {
        progress = 33;
        text = 'Plus qu’un maillot avant de débloquer votre cadeau.';
      } else if (cycle === 3) {
        progress = 66;
        text = 'Cadeau débloqué 🎁 Ajoutez maintenant votre 4e maillot.';
        unlocked = true;
      } else {
        progress = 100;
        text = 'Votre 4e maillot est débloqué 🎉';
        unlocked = true;
      }

      if (bar) bar.style.width = progress + '%';
      if (message) message.textContent = text;
      if (countBadge) countBadge.textContent = projectedTotal + ' article' + (projectedTotal > 1 ? 's' : '');

      step1?.classList.toggle('is-active', projectedTotal >= 1);
      step2?.classList.toggle('is-active', projectedTotal >= 2);
      step3?.classList.toggle('is-active', projectedTotal >= 3);
      gift?.classList.toggle('is-active', projectedTotal > 0 && projectedTotal % 4 === 0);

      offer.classList.toggle('is-unlocked', unlocked);
      offer.classList.remove('fc-offer-pulse');
      void offer.offsetWidth;
      offer.classList.add('fc-offer-pulse');
    };

    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);

    form.querySelector('[data-fc-qty-minus]')?.addEventListener('click', () => setTimeout(render, 0));
    form.querySelector('[data-fc-qty-plus]')?.addEventListener('click', () => setTimeout(render, 0));

    render();
  });
});


// FC V96 — panier AJAX : + / − sans rechargement de page
// Met à jour le prix, le total, l'offre 3+1 et la pastille panier en arrière-plan.
document.addEventListener('DOMContentLoaded', () => {
  let fcCartBusy = false;

  const refreshMiniDelivery = (root = document) => {
    const isBusinessDay = (date) => ![0, 6].includes(date.getDay());
    const addBusinessDays = (date, amount) => {
      const result = new Date(date);
      let added = 0;
      while (added < amount) {
        result.setDate(result.getDate() + 1);
        if (isBusinessDay(result)) added++;
      }
      return result;
    };
    const format = (date) => new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit' }).format(date);
    const now = new Date();
    const start = addBusinessDays(now, 8);
    const finish = addBusinessDays(now, 14);
    root.querySelectorAll('[data-fc-mini-delivery-range]').forEach((el) => {
      el.textContent = `${format(start)} - ${format(finish)}`;
    });
  };

  const setBusy = (busy) => {
    fcCartBusy = busy;
    const page = document.querySelector('.fc-cart-page');
    if (!page) return;
    page.classList.toggle('is-ajax-updating', busy);
    page.querySelectorAll('[data-fc-cart-minus], [data-fc-cart-plus], [data-fc-cart-input]').forEach((el) => {
      el.disabled = busy;
    });
  };

  const updateCart = async (input, quantity) => {
    if (fcCartBusy) return;
    const itemKey = input.dataset.itemKey || '';
    if (!itemKey) return;

    quantity = Math.max(0, parseInt(quantity || '0', 10));
    input.value = quantity;
    setBusy(true);

    try {
      const changeResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity })
      });
      if (!changeResponse.ok) throw new Error('Impossible de mettre à jour le panier');

      const cart = await changeResponse.json();
      const htmlResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart`, {
        headers: { 'Accept': 'text/html' }
      });
      if (!htmlResponse.ok) throw new Error('Impossible de rafraîchir le panier');

      const html = await htmlResponse.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshPage = doc.querySelector('.fc-cart-page');
      const currentPage = document.querySelector('.fc-cart-page');
      if (freshPage && currentPage) {
        currentPage.replaceWith(freshPage);
        refreshMiniDelivery(freshPage);
      }

      // Synchronise la pastille du panier dans le header sans recharger la page.
      const headerCart = document.querySelector('.fc-header__cart, [href="/cart"]');
      let badge = document.querySelector('.fc-cart-count');
      if (cart.item_count > 0) {
        if (!badge && headerCart) {
          badge = document.createElement('span');
          badge.className = 'fc-cart-count';
          headerCart.appendChild(badge);
        }
        if (badge) badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    } catch (error) {
      console.error('[FC Maillot] Panier AJAX :', error);
      // En cas d'erreur réseau, on restaure la valeur réellement connue par Shopify.
      window.location.reload();
    } finally {
      setBusy(false);
    }
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-fc-cart-minus]');
    const plus = event.target.closest('[data-fc-cart-plus]');
    if (!minus && !plus) return;

    const control = event.target.closest('[data-fc-cart-quantity]');
    const input = control?.querySelector('[data-fc-cart-input]');
    if (!input || fcCartBusy) return;

    event.preventDefault();
    const current = Math.max(0, parseInt(input.value || '0', 10));
    const next = minus ? Math.max(0, current - 1) : current + 1;
    control.classList.add('is-changing');
    updateCart(input, next);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-fc-cart-input]');
    if (!input || fcCartBusy) return;
    updateCart(input, input.value);
  });

  refreshMiniDelivery();
});


// FC V18 — estimation de livraison dynamique
document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('[data-fc-delivery-estimate]');
  if (!widgets.length) return;

  const locale = 'fr-FR';

  const isBusinessDay = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const addBusinessDays = (date, amount) => {
    const result = new Date(date);
    let added = 0;
    while (added < amount) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) added++;
    }
    return result;
  };

  const formatShort = (date) =>
    new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' }).format(date);

  const formatLong = (date) =>
    new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' }).format(date);

  const now = new Date();

  // Préparation : 2–3 jours ouvrés ; livraison France : 10–14 jours ouvrés.
  const shipStart = addBusinessDays(now, 2);
  const shipEnd = addBusinessDays(now, 3);
  const deliveryStart = addBusinessDays(now, 8);
  const deliveryEnd = addBusinessDays(now, 14);

  document.querySelectorAll('[data-fc-mini-delivery-range]').forEach((el) => {
    el.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} - ${formatShort(deliveryEnd)}`));
  });

  widgets.forEach((widget) => {
    widget.querySelector('[data-fc-order-date]')?.replaceChildren(document.createTextNode(formatShort(now)));
    widget.querySelector('[data-fc-ship-range]')?.replaceChildren(document.createTextNode(`${formatShort(shipStart)} – ${formatShort(shipEnd)}`));
    widget.querySelector('[data-fc-delivery-range]')?.replaceChildren(document.createTextNode(`${formatLong(deliveryStart)} et ${formatLong(deliveryEnd)}`));
    widget.querySelector('[data-fc-delivery-range-bottom]')?.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} – ${formatShort(deliveryEnd)}`));
    widget.querySelector('[data-fc-tooltip-delivery-range]')?.replaceChildren(document.createTextNode(`${formatShort(deliveryStart)} – ${formatShort(deliveryEnd)}`));
  });

  // Compte à rebours quotidien jusqu'à 23:59:59, uniquement informatif.
  const updateCountdown = () => {
    const current = new Date();
    const end = new Date(current);
    end.setHours(23, 59, 59, 999);

    let diff = Math.max(0, end - current);
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);

    const text =
      `${String(hours).padStart(2, '0')}h ` +
      `${String(minutes).padStart(2, '0')}m ` +
      `${String(seconds).padStart(2, '0')}s`;

    widgets.forEach((widget) => {
      const el = widget.querySelector('[data-fc-order-countdown]');
      if (el) el.textContent = text;
    });
  };

  updateCountdown();
  setInterval(updateCountdown, 1000);
});


// FC V23 — carrousel produits responsive
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-carousel-section]').forEach((section) => {
    const carousel = section.querySelector('[data-fc-product-carousel]');
    const slides = [...section.querySelectorAll('[data-fc-carousel-slide]')];
    const prev = section.querySelector('[data-fc-carousel-prev]');
    const next = section.querySelector('[data-fc-carousel-next]');
    const dotsWrap = section.querySelector('[data-fc-carousel-dots]');
    const shell = section.querySelector('.fc-carousel-shell');

    if (!carousel || slides.length === 0) return;

    const stepSize = () => {
      const first = slides[0];
      if (!first) return carousel.clientWidth;
      const style = getComputedStyle(carousel);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const maxScroll = () => Math.max(0, carousel.scrollWidth - carousel.clientWidth);

    const pageCount = () => {
      const step = stepSize();
      if (!step) return 1;
      return Math.max(1, Math.round(maxScroll() / step) + 1);
    };

    let dots = [];

    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const count = pageCount();

      // Keep the UI compact even with many products.
      const maxDots = Math.min(count, slides.length);
      for (let i = 0; i < maxDots; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fc-carousel-dot';
        dot.setAttribute('aria-label', `Aller au produit ${i + 1}`);
        dot.addEventListener('click', () => {
          carousel.scrollTo({ left: Math.min(i * stepSize(), maxScroll()), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      dots = [...dotsWrap.children];
    };

    const update = () => {
      const step = stepSize() || 1;
      const index = Math.round(carousel.scrollLeft / step);
      const max = maxScroll();

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === Math.min(index, dots.length - 1)));
      slides.forEach((slide, i) => slide.classList.toggle('is-current', i === index));

      if (shell) {
        shell.classList.toggle('can-scroll-left', carousel.scrollLeft > 4);
        shell.classList.toggle('can-scroll-right', carousel.scrollLeft < max - 4);
      }
    };

    const goNext = () => {
      const max = maxScroll();
      if (carousel.scrollLeft >= max - 5) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: stepSize(), behavior: 'smooth' });
      }
    };

    const goPrev = () => {
      const max = maxScroll();
      if (carousel.scrollLeft <= 5) {
        carousel.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      }
    };

    prev?.addEventListener('click', goPrev);
    next?.addEventListener('click', goNext);

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goNext();
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goPrev();
      }
    });

    let ticking = false;
    carousel.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive:true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buildDots();
        update();
      }, 140);
    });

    buildDots();
    update();
  });
});


// FC V25 — galerie produit multi-images + plein écran
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-fc-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-fc-gallery-thumb]')];
    const prev = gallery.querySelector('[data-fc-gallery-prev]');
    const next = gallery.querySelector('[data-fc-gallery-next]');
    const counter = gallery.querySelector('[data-fc-gallery-current]');

    let current = 0;

    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
        slide.classList.toggle('is-active', i === current);
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
      });
      if (counter) counter.textContent = String(current + 1);
      thumbs[current]?.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' });
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));

    // Swipe on the main image.
    let startX = null;
    const main = gallery.querySelector('[data-fc-gallery-main]');
    main?.addEventListener('touchstart', (e) => {
      startX = e.touches[0]?.clientX ?? null;
    }, { passive:true });
    main?.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const endX = e.changedTouches[0]?.clientX ?? startX;
      const delta = endX - startX;
      startX = null;
      if (Math.abs(delta) < 45) return;
      if (delta < 0) show(current + 1);
      else show(current - 1);
    }, { passive:true });

    // Fullscreen lightbox: images only.
    const lightbox = gallery.querySelector('[data-fc-product-lightbox]');
    const lightboxImages = lightbox ? [...lightbox.querySelectorAll('[data-fc-lightbox-image]')] : [];

    // V34: sortir le viewer de la galerie pour garantir un vrai plein écran
    // même si un parent utilise transform / contain / overflow sur iOS Safari.
    if (lightbox && lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    const closeButtons = lightbox ? lightbox.querySelectorAll('[data-fc-lightbox-close]') : [];
    const lightPrev = lightbox?.querySelector('[data-fc-lightbox-prev]');
    const lightNext = lightbox?.querySelector('[data-fc-lightbox-next]');
    const lightCounter = lightbox?.querySelector('[data-fc-lightbox-current]');

    let lightIndex = 0;

    const showLight = (index) => {
      if (!lightboxImages.length) return;
      lightIndex = (index + lightboxImages.length) % lightboxImages.length;
      lightboxImages.forEach((img, i) => img.hidden = i !== lightIndex);
      if (lightCounter) lightCounter.textContent = String(lightIndex + 1);
    };

    const openLightbox = (mediaIndex) => {
      if (!lightbox || !lightboxImages.length) return;
      const matching = lightboxImages.findIndex((img) =>
        Number(img.dataset.mediaIndex) === Number(mediaIndex)
      );
      showLight(matching >= 0 ? matching : 0);
      lightbox.hidden = false;
      document.documentElement.classList.add('fc-lightbox-open');
      document.body.classList.add('fc-lightbox-open');
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('fc-lightbox-open');
      document.body.classList.remove('fc-lightbox-open');
    };

    gallery.querySelectorAll('[data-fc-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => openLightbox(button.dataset.mediaIndex));
    });
    closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
    lightPrev?.addEventListener('click', () => showLight(lightIndex - 1));
    lightNext?.addEventListener('click', () => showLight(lightIndex + 1));

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showLight(lightIndex - 1);
      if (event.key === 'ArrowRight') showLight(lightIndex + 1);
    });

    show(0);
  });
});


// FC V41 — infos livraison au toucher
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-delivery-estimate]').forEach((widget) => {
    const steps = [...widget.querySelectorAll('[data-fc-delivery-step]')];
    if (!steps.length) return;

    const closeAll = (except = null) => {
      steps.forEach((step) => {
        if (step === except) return;
        step.classList.remove('is-tooltip-open');
        step.setAttribute('aria-expanded', 'false');
      });

      const hasOpen = steps.some((step) => step.classList.contains('is-tooltip-open'));
      widget.classList.toggle('has-tooltip-open', hasOpen);
    };

    steps.forEach((step) => {
      step.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = !step.classList.contains('is-tooltip-open');
        closeAll(step);
        step.classList.toggle('is-tooltip-open', open);
        step.setAttribute('aria-expanded', open ? 'true' : 'false');
        widget.classList.toggle('has-tooltip-open', open);
      });
    });

    document.addEventListener('click', (event) => {
      if (!widget.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  });
});


// FCCROCS V26 — la recherche du header utilise désormais la page de recherche native du thème.

// FC V68 — guide des tailles intelligent + animations + flocage en majuscules
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[name="properties[Flocage haut]"], input[name="properties[Flocage bas]"]').forEach(input => {
    input.style.textTransform = 'uppercase';
    input.addEventListener('input', () => { input.value = input.value.toLocaleUpperCase('fr-FR'); });
    input.addEventListener('blur', () => { input.value = input.value.toLocaleUpperCase('fr-FR'); });
  });

  document.querySelectorAll('[data-fc-size-guide]').forEach(guide => {
    const form = guide.closest('form'); const select = form?.querySelector('[data-variant-select]');
    const open = form?.querySelector('[data-fc-size-open]'); const closes = guide.querySelectorAll('[data-fc-size-close]');
    const result = guide.querySelector('[data-fc-size-result]'); const message = guide.querySelector('[data-fc-size-message]'); const choose = guide.querySelector('[data-fc-size-choose]');
    let recommendation = ''; let mode = guide.dataset.jacket === 'true' ? 'adult' : 'adult'; let fit = 'normal';
    const norm = s => (s||'').toUpperCase().replace(/\s+/g,'').replace('XXL','2XL');
    const variantFor = size => select ? [...select.options].find(o => norm(o.textContent).includes(norm(size))) : null;
    const show = () => { guide.hidden=false; document.body.classList.add('fc-size-lock'); requestAnimationFrame(()=>guide.classList.add('is-open')); setTimeout(update,0); };
    const hide = () => { guide.classList.remove('is-open'); document.body.classList.remove('fc-size-lock'); setTimeout(()=>{guide.hidden=true},260); };
    open?.addEventListener('click', show); closes.forEach(x=>x.addEventListener('click', hide));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!guide.hidden)hide()});
    guide.querySelectorAll('[data-fc-size-tab]').forEach(btn=>btn.addEventListener('click',()=>{mode=btn.dataset.fcSizeTab;guide.querySelectorAll('[data-fc-size-tab]').forEach(b=>b.classList.toggle('is-active',b===btn));guide.querySelectorAll('[data-fc-size-pane]').forEach(p=>p.hidden=p.dataset.fcSizePane!==mode);update()}));
    guide.querySelectorAll('[data-fc-fit]').forEach(btn=>btn.addEventListener('click',()=>{fit=btn.dataset.fcFit;guide.querySelectorAll('[data-fc-fit]').forEach(b=>b.classList.toggle('is-active',b===btn));update()}));
    const ranges=[['[data-fc-height]','[data-fc-height-out]'],['[data-fc-weight]','[data-fc-weight-out]'],['[data-fc-child-age]','[data-fc-child-age-out]'],['[data-fc-child-height]','[data-fc-child-height-out]'],['[data-fc-child-weight]','[data-fc-child-weight-out]']];
    ranges.forEach(([a,b])=>{const i=guide.querySelector(a),o=guide.querySelector(b);i?.addEventListener('input',()=>{if(o)o.textContent=i.value;update()})});
    function update(){
      let size='';
      if(guide.dataset.jacket==='true'){
        const h=+guide.querySelector('[data-fc-height]')?.value||175,w=+guide.querySelector('[data-fc-weight]')?.value||65;
        const scores=[['S',166.5,55],['M',172.5,62.5],['L',177.5,69],['XL',182.5,78.5],['2XL',182.5,86.5],['3XL',190,93.5],['4XL',197.5,101.5]];
        size=scores.sort((a,b)=>((h-a[1])/7)**2+((w-a[2])/10)**2-(((h-b[1])/7)**2+((w-b[2])/10)**2))[0][0];
      } else if(mode==='child'){
        const age=+guide.querySelector('[data-fc-child-age]')?.value||8;
        const h=+guide.querySelector('[data-fc-child-height]')?.value||135;
        const w=+guide.querySelector('[data-fc-child-weight]')?.value||30;
        const child=[['2-3 ans',2.5,100,15],['3-4 ans',3.5,110,18],['4-5 ans',4.5,120,21],['6-7 ans',6.5,130,25],['8-9 ans',8.5,140,31],['10-11 ans',10.5,150,39],['12-13 ans',12.5,160,48]];
        size=child.slice().sort((a,b)=>(((age-a[1])/1.8)**2+((h-a[2])/10)**2+((w-a[3])/9)**2)-(((age-b[1])/1.8)**2+((h-b[2])/10)**2+((w-b[3])/9)**2))[0][0];
      } else {
        const h=+guide.querySelector('[data-fc-height]')?.value||175;
        const w=+guide.querySelector('[data-fc-weight]')?.value||70;
        const adult=[['S',165,55],['M',170,63],['L',175,72],['XL',180,82],['2XL',185,92],['3XL',190,103],['4XL',195,115]];
        let idx=adult.slice().sort((a,b)=>(((h-a[1])/7)**2+((w-a[2])/11)**2)-(((h-b[1])/7)**2+((w-b[2])/11)**2))[0];
        let pos=adult.findIndex(x=>x[0]===idx[0]); if(fit==='tight')pos=Math.max(0,pos-1);if(fit==='loose')pos=Math.min(adult.length-1,pos+1);size=adult[pos][0];
      }
      recommendation=size; result.classList.remove('fc-reco-pop'); void result.offsetWidth; result.classList.add('fc-reco-pop'); result.textContent=size; const opt=variantFor(size);
      message.textContent=opt&&!opt.disabled?'On te conseille la taille '+size:'Taille '+size+' conseillée — vérifie sa disponibilité';
      choose.disabled=!opt||opt.disabled; choose.textContent=opt&&!opt.disabled?'Choisir la taille '+size:'Taille non disponible';
    }
    choose?.addEventListener('click',()=>{const opt=variantFor(recommendation);if(!opt||opt.disabled)return;select.value=opt.value;select.dispatchEvent(new Event('change',{bubbles:true}));hide();select.scrollIntoView({behavior:'smooth',block:'center'})});
    update();
  });
});

// FC V72 — pagination + indice de swipe pour Championnats et Pays
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fc-hub-section]').forEach(section => {
    const carousel = section.querySelector('[data-fc-hub-carousel]');
    const slides = [...section.querySelectorAll('[data-fc-hub-slide]')];
    const dotsWrap = section.querySelector('[data-fc-hub-dots]');
    if (!carousel || !slides.length || !dotsWrap) return;
    let dots=[];
    const step=()=>{const s=getComputedStyle(carousel);return slides[0].getBoundingClientRect().width+(parseFloat(s.columnGap||s.gap||0)||0)};
    const max=()=>Math.max(0,carousel.scrollWidth-carousel.clientWidth);
    const count=()=>Math.max(1,Math.round(max()/(step()||1))+1);
    const build=()=>{dotsWrap.innerHTML='';for(let i=0;i<count();i++){const d=document.createElement('button');d.type='button';d.className='fc-carousel-dot';d.setAttribute('aria-label',`Aller à la carte ${i+1}`);d.addEventListener('click',()=>carousel.scrollTo({left:Math.min(i*step(),max()),behavior:'smooth'}));dotsWrap.appendChild(d)}dots=[...dotsWrap.children];update()};
    const update=()=>{const i=Math.round(carousel.scrollLeft/(step()||1));dots.forEach((d,n)=>d.classList.toggle('is-active',n===Math.min(i,dots.length-1)))};
    let ticking=false;carousel.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(()=>{update();ticking=false});ticking=true}},{passive:true});
    let timer;window.addEventListener('resize',()=>{clearTimeout(timer);timer=setTimeout(build,140)});build();
  });
});

/* FC MAILLOT V85 — subtle desktop parallax for the existing hero artwork */
(() => {
  const hero = document.querySelector('.fc-hero__box');
  if (!hero || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  let raf = 0;
  hero.addEventListener('pointermove', (e) => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const r = hero.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width - .5) * -12;
      const y = ((e.clientY - r.top) / r.height - .5) * -8;
      hero.style.setProperty('--fc-hero-x', `${x.toFixed(2)}px`);
      hero.style.setProperty('--fc-hero-y', `${y.toFixed(2)}px`);
    });
  }, { passive:true });
  hero.addEventListener('pointerleave', () => {
    hero.style.setProperty('--fc-hero-x', '0px');
    hero.style.setProperty('--fc-hero-y', '0px');
  });
})();



// FCCROCS V12 — sélection visuelle de plusieurs pins par images.
// Chaque image est un bouton : clic = sélection rose persistante, second clic = retrait.
// Le clic affiche aussi immédiatement le média de la variante dans la grande galerie.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fcc-pin-multi]').forEach((builder) => {
    const form = builder.closest('[data-fc-product-form]');
    const select = form?.querySelector('[data-fcc-pin-variant-select]');
    const picker = form?.querySelector('[data-fcc-pin-image-picker]');
    const choices = picker ? [...picker.querySelectorAll('[data-fcc-pin-image-choice]')] : [];
    const list = builder.querySelector('[data-fcc-pin-list]');
    const empty = builder.querySelector('[data-fcc-pin-empty]');
    const footer = builder.querySelector('[data-fcc-pin-footer]');
    const totalCountEl = builder.querySelector('[data-fcc-pin-total-count]');
    const totalCountTopEl = form?.querySelector('[data-fcc-pin-total-count-top]');
    const totalPriceEl = builder.querySelector('[data-fcc-pin-total-price]');
    const qty = form?.querySelector('[data-fcc-pin-multi-quantity]');
    const qtyInput = qty?.querySelector('[data-fc-qty-input]');
    const qtyMinus = qty?.querySelector('[data-fc-qty-minus]');
    const qtyPlus = qty?.querySelector('[data-fc-qty-plus]');
    const submit = form?.querySelector('[data-fcc-pin-multi-submit]');
    const topPrice = form?.closest('.fc-product__info')?.querySelector('[data-product-price]');
    if (!form || !select || !picker || !list || !qtyInput || !submit || choices.length === 0) return;

    const selection = new Map();
    let isSubmitting = false;
    const defaultUnitPriceCents = Math.max(0, parseInt(submit.dataset.unitPriceCents || choices[0]?.dataset.priceCents || '0', 10));

    const money = (cents) => {
      const currency = builder.dataset.currency || submit.dataset.currency || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
          style: 'currency', currency
        }).format(cents / 100);
      } catch (_) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
    };

    const totalCount = () => [...selection.values()].reduce((sum, item) => sum + item.quantity, 0);
    const totalCents = () => [...selection.values()].reduce((sum, item) => sum + item.priceCents * item.quantity, 0);

    const optionFor = (id) => [...select.options].find((option) => String(option.value) === String(id));
    const choiceFor = (id) => choices.find((choice) => String(choice.dataset.variantId) === String(id));

    const showVariant = (id) => {
      const option = optionFor(id);
      if (!option || option.disabled) return;
      select.value = String(id);
      // Réutilise le moteur de galerie déjà présent dans le thème.
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const addChoice = (choice) => {
      if (!choice || choice.disabled) return;
      const id = String(choice.dataset.variantId || '');
      if (!id) return;
      selection.set(id, {
        id,
        title: choice.dataset.variantTitle || '',
        priceCents: Math.max(0, parseInt(choice.dataset.priceCents || '0', 10)),
        quantity: 1,
        imageSrc: choice.dataset.imageSrc || ''
      });
    };

    const removeChoice = (id) => selection.delete(String(id));

    const render = () => {
      const count = totalCount();
      const cents = totalCents();
      qtyInput.value = String(count);

      if (totalCountEl) {
        totalCountEl.textContent = String(count);
        const badge = totalCountEl.closest('.fcc-pin-multi__badge');
        if (badge) badge.lastChild.textContent = count > 1 ? ' pins' : ' pin';
      }
      if (totalCountTopEl) {
        totalCountTopEl.textContent = String(count);
        const wrap = totalCountTopEl.closest('.fcc-pin-picker-count');
        if (wrap) wrap.lastChild.textContent = count > 1 ? ' sélectionnés' : ' sélectionné';
      }
      if (totalPriceEl) totalPriceEl.textContent = money(cents);
      // Le prix affiché sous le titre reste fixe : c'est le prix unitaire du pin.
      if (topPrice) topPrice.textContent = money(defaultUnitPriceCents);

      empty.hidden = count > 0;
      list.hidden = count === 0;
      if (footer) footer.hidden = count === 0;
      submit.disabled = count === 0 || isSubmitting;
      submit.textContent = count > 0
        ? `Ajouter ${count} pin${count > 1 ? 's' : ''} au panier — ${money(cents)}`
        : 'Choisis au moins un pin';

      if (qtyPlus) qtyPlus.disabled = true;
      if (qtyMinus) qtyMinus.disabled = true;

      choices.forEach((choice) => {
        const selected = selection.has(String(choice.dataset.variantId));
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        const baseLabel = choice.dataset.variantTitle || choice.getAttribute('title') || 'ce pin';
        choice.setAttribute('aria-label', selected ? `Retirer ${baseLabel} de la sélection` : `Sélectionner ${baseLabel}`);
      });

      list.innerHTML = '';
      selection.forEach((item) => {
        const card = document.createElement('div');
        card.className = 'fcc-pin-selected-card';
        card.dataset.variantId = item.id;

        const media = document.createElement('button');
        media.type = 'button';
        media.className = 'fcc-pin-selected-card__media';
        media.dataset.fccPinSelectedPreview = '';
        media.setAttribute('aria-label', item.title ? `Afficher ${item.title}` : 'Afficher ce pin');
        if (item.imageSrc) {
          const img = document.createElement('img');
          img.src = item.imageSrc;
          img.alt = item.title || 'Pin sélectionné';
          img.loading = 'lazy';
          media.appendChild(img);
        } else {
          const fallback = document.createElement('span');
          fallback.textContent = 'PIN';
          media.appendChild(fallback);
        }

        const check = document.createElement('span');
        check.className = 'fcc-pin-selected-card__check';
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        media.appendChild(check);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'fcc-pin-selected-card__remove';
        remove.dataset.fccPinItemRemove = '';
        remove.setAttribute('aria-label', item.title ? `Retirer ${item.title}` : 'Retirer ce pin');
        remove.textContent = '×';

        card.append(media, remove);
        list.appendChild(card);
      });
    };

    picker.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-fcc-pin-image-choice]');
      if (!choice || choice.disabled) return;
      const id = String(choice.dataset.variantId || '');
      if (!id) return;

      // Toujours montrer l'image du pin touché dans la grande galerie.
      showVariant(id);

      // Sélection multiple persistante : rose = choisi.
      if (selection.has(id)) removeChoice(id);
      else addChoice(choice);
      render();
    });

    list.addEventListener('click', (event) => {
      const card = event.target.closest('[data-variant-id]');
      if (!card) return;
      const id = card.dataset.variantId;
      if (event.target.closest('[data-fcc-pin-selected-preview]')) {
        showVariant(id);
        return;
      }
      if (event.target.closest('[data-fcc-pin-item-remove]')) {
        removeChoice(id);
        render();
      }
    });

    form.addEventListener('submit', async (event) => {
      if (!form.querySelector('[data-fcc-pin-multi-submit]')) return;
      event.preventDefault();
      if (selection.size === 0 || isSubmitting) return;

      isSubmitting = true;
      render();
      submit.textContent = 'Ajout de ta sélection…';

      const items = [...selection.values()].map((item) => ({
        id: Number(item.id),
        quantity: item.quantity
      }));

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'Impossible d’ajouter la sélection au panier.');
        }
        window.location.href = `${root}cart`;
      } catch (error) {
        console.error('[FCCROCS] Ajout multi-variantes :', error);
        isSubmitting = false;
        render();
        submit.textContent = 'Réessayer — une erreur est survenue';
        setTimeout(render, 2200);
      }
    });

    render();
  });
});

// FCCROCS V5 — plusieurs visuels : 1 image = 1 pin = +1 quantité
// Chaque image conserve son propre champ fichier Shopify afin d'être attachée à la commande.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-fcc-upload]').forEach((wrap) => {
    const form = wrap.closest('[data-fc-product-form]');
    const inputsBox = wrap.querySelector('[data-fcc-file-inputs]');
    const addButton = wrap.querySelector('[data-fcc-upload-add]');
    const list = wrap.querySelector('[data-fcc-file-list]');
    const counter = wrap.querySelector('[data-fcc-upload-counter]');
    const countText = wrap.querySelector('[data-fcc-image-count]');
    const error = wrap.querySelector('[data-fcc-file-error]');
    const qty = form?.querySelector('[data-fc-quantity][data-fcc-auto-quantity]');
    const qtyInput = qty?.querySelector('[data-fc-qty-input]');
    const plus = qty?.querySelector('[data-fc-qty-plus]');
    const minus = qty?.querySelector('[data-fc-qty-minus]');
    const submit = form?.querySelector('[data-fcc-submit]');
    const topPrice = form?.closest('.fc-product__info')?.querySelector('[data-product-price]');
    const variantSelect = form?.querySelector('[data-variant-select]');
    if (!form || !inputsBox || !addButton || !list || !qtyInput) return;

    const allowed = ['image/png', 'image/jpeg', 'image/webp'];
    const objectUrls = new Map();
    let activeInput = inputsBox.querySelector('[data-fcc-file]');

    const money = (cents) => {
      const currency = submit?.dataset.currency || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style:'currency', currency }).format(cents / 100);
      } catch (_) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
    };

    const storedInputs = () => Array.from(inputsBox.querySelectorAll('[data-fcc-stored="true"]'));

    const currentUnitPrice = () => {
      const selected = variantSelect?.options?.[variantSelect.selectedIndex];
      return Math.max(0, parseInt(selected?.dataset.priceCents || submit?.dataset.unitPriceCents || '0', 10));
    };

    const renumber = () => {
      storedInputs().forEach((input, index) => {
        input.name = `properties[Aperçu du pin ${index + 1} ↗]`;
        input.dataset.fccIndex = String(index + 1);
        const card = list.querySelector(`[data-fcc-preview-id="${input.id}"]`);
        const badge = card?.querySelector('[data-fcc-preview-number]');
        if (badge) badge.textContent = `VISUEL ${index + 1}`;
      });
    };

    const sync = () => {
      const count = storedInputs().length;
      qtyInput.value = Math.max(1, count);
      if (countText) countText.textContent = String(count);
      if (counter) {
        const span = counter.querySelector('span');
        if (span) span.lastChild.textContent = count > 1 ? ' images sélectionnées' : ' image sélectionnée';
      }
      list.hidden = count === 0;
      minus?.toggleAttribute('disabled', count === 0);
      if (error && count > 0) error.hidden = true;
      const total = currentUnitPrice() * Math.max(1, count);
      // Le prix sous le titre reste unitaire ; seul le bouton suit la quantité.
      if (topPrice) topPrice.textContent = money(currentUnitPrice());
      if (submit && !submit.disabled) {
        submit.textContent = `Ajouter au panier — ${money(total)}`;
      }
      qtyInput.dispatchEvent(new Event('input', { bubbles:true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles:true }));
    };

    const makePicker = () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.className = 'fcc-file fcc-file--picker';
      input.accept = '.png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp';
      input.setAttribute('data-fcc-file', '');
      input.id = `FccCustomFile-${Date.now()}-${Math.random().toString(36).slice(2,8)}`;
      inputsBox.appendChild(input);
      bindPicker(input);
      activeInput = input;
      return input;
    };

    const removeStoredInput = (input) => {
      const url = objectUrls.get(input);
      if (url) URL.revokeObjectURL(url);
      objectUrls.delete(input);
      list.querySelector(`[data-fcc-preview-id="${input.id}"]`)?.remove();
      input.remove();
      renumber();
      sync();
    };

    const addPreview = (input, file) => {
      const url = URL.createObjectURL(file);
      objectUrls.set(input, url);
      const card = document.createElement('div');
      card.className = 'fcc-upload__preview fcc-upload__preview--multi';
      card.dataset.fccPreviewId = input.id;
      card.innerHTML = `
        <div class="fcc-upload__preview-media"><img src="${url}" alt="Aperçu du visuel choisi"><span data-fcc-preview-number>VISUEL</span></div>
        <div class="fcc-upload__preview-copy"><strong></strong><small>1 image = 1 pin ajouté au panier.</small></div>
        <button type="button" aria-label="Supprimer cette image">×</button>`;
      card.querySelector('strong').textContent = file.name;
      card.querySelector('button').addEventListener('click', () => removeStoredInput(input));
      list.appendChild(card);
    };

    function bindPicker(input) {
      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file) return;
        if (!allowed.includes(file.type)) {
          input.value = '';
          if (error) {
            error.textContent = 'Choisis une image PNG, JPG ou WEBP.';
            error.hidden = false;
          }
          return;
        }
        input.dataset.fccStored = 'true';
        addPreview(input, file);
        makePicker();
        renumber();
        sync();
      });
    }

    if (activeInput) bindPicker(activeInput);
    else activeInput = makePicker();

    addButton.addEventListener('click', () => activeInput?.click());
    plus?.addEventListener('click', () => activeInput?.click());
    minus?.addEventListener('click', () => {
      const items = storedInputs();
      if (items.length) removeStoredInput(items[items.length - 1]);
    });

    variantSelect?.addEventListener('change', () => setTimeout(sync, 0));

    form.addEventListener('submit', (event) => {
      if (storedInputs().length === 0) {
        event.preventDefault();
        if (error) {
          error.textContent = 'Ajoute au moins une image avant de mettre ce produit au panier.';
          error.hidden = false;
        }
        wrap.scrollIntoView({ behavior:'smooth', block:'center' });
        activeInput?.focus({ preventScroll:true });
      } else {
        renumber();
        sync();
      }
    });

    sync();
  });
});


// =========================================================
// FCCROCS V30 — recherche avec images + collections en premier + pointure panier
// + guide de pointure selon la longueur du pied
// =========================================================
document.addEventListener('DOMContentLoaded', () => {
  /* ---------- Recherche compacte du header ---------- */
  const searchLayer = document.querySelector('[data-fcc-header-search]');
  const searchPanel = searchLayer?.querySelector('.fcc-header-search__panel');
  const searchInput = searchLayer?.querySelector('[data-fcc-header-search-input]');
  const searchResults = searchLayer?.querySelector('[data-fcc-header-search-results]');
  const searchOpeners = [...document.querySelectorAll('[data-fcc-search-open]')];
  const searchClosers = searchLayer ? [...searchLayer.querySelectorAll('[data-fcc-search-close]')] : [];
  let searchTimer = null;
  let searchController = null;

  const positionHeaderSearch = () => {
    if (!searchLayer) return;
    const header = document.querySelector('.fc-header-wrap');
    const rect = header?.getBoundingClientRect();
    const top = Math.max(10, Math.round((rect?.bottom || 72) + 10));
    searchLayer.style.setProperty('--fcc-search-top', `${top}px`);
  };

  const openHeaderSearch = (event) => {
    if (!searchLayer) return;
    event?.preventDefault();

    // V32 : depuis le menu latéral, on ferme le tiroir puis on ouvre
    // exactement la même recherche flottante que la loupe du header.
    const drawerOpener = event?.currentTarget?.matches?.('[data-fcc-menu-search]');
    if (drawerOpener) {
      const drawer = document.querySelector('[data-fc-mobile-menu]');
      const menuButton = document.querySelector('[data-fc-menu-open]');
      if (drawer) {
        drawer.classList.remove('is-open');
        window.setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 180);
      }
      if (menuButton) {
        menuButton.classList.remove('is-menu-open');
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Ouvrir le menu');
      }
      document.body.classList.remove('fc-menu-lock');
    }

    positionHeaderSearch();
    searchLayer.hidden = false;
    searchLayer.classList.add('is-open');
    searchOpeners.forEach((opener) => opener.setAttribute('aria-expanded', 'true'));
    window.setTimeout(() => {
      searchInput?.focus({ preventScroll: true });
      if (searchInput?.value?.trim()) searchInput.select();
    }, 40);
  };

  const closeHeaderSearch = () => {
    if (!searchLayer) return;
    searchLayer.classList.remove('is-open');
    searchOpeners.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { searchLayer.hidden = true; }, 180);
  };

  searchOpeners.forEach((opener) => opener.addEventListener('click', openHeaderSearch));
  searchClosers.forEach((closer) => closer.addEventListener('click', closeHeaderSearch));
  window.addEventListener('resize', positionHeaderSearch, { passive: true });
  window.addEventListener('scroll', positionHeaderSearch, { passive: true });

  document.addEventListener('pointerdown', (event) => {
    if (!searchLayer || searchLayer.hidden || !searchPanel) return;
    if (searchPanel.contains(event.target) || searchOpeners.some((opener) => opener.contains(event.target))) return;
    closeHeaderSearch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchLayer && !searchLayer.hidden) closeHeaderSearch();
  });

  const resultImageUrl = (item) => {
    if (!item) return '';
    const candidates = [
      item.image,
      item.featured_image,
      item.featuredImage,
      item.thumbnail,
      item.image_url,
      item.featured_image_url
    ];
    for (const candidate of candidates) {
      if (!candidate) continue;
      if (typeof candidate === 'string') return candidate.startsWith('//') ? `https:${candidate}` : candidate;
      if (typeof candidate === 'object') {
        const url = candidate.url || candidate.src || candidate.originalSrc || candidate.transformedSrc;
        if (url) return String(url).startsWith('//') ? `https:${url}` : String(url);
      }
    }
    return '';
  };

  const makeResultLink = (item, typeLabel) => {
    const link = document.createElement('a');
    link.className = 'fcc-header-search-result';
    link.href = item.url || '#';

    const media = document.createElement('span');
    media.className = 'fcc-header-search-result__icon';
    const fallbackIcon = typeLabel === 'Produit' ? '🛍' : typeLabel === 'Collection' ? '▦' : '▤';
    media.textContent = fallbackIcon;

    const imageUrl = resultImageUrl(item);
    if (imageUrl && typeLabel !== 'Page') {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('load', () => media.classList.add('has-image'), { once: true });
      image.addEventListener('error', () => image.remove(), { once: true });
      media.appendChild(image);
    }

    const copy = document.createElement('span');
    copy.className = 'fcc-header-search-result__copy';

    const title = document.createElement('strong');
    title.textContent = item.title || 'Résultat';
    const meta = document.createElement('small');
    meta.textContent = typeLabel;

    copy.append(title, meta);
    link.append(media, copy);

    const arrow = document.createElement('span');
    arrow.className = 'fcc-header-search-result__arrow';
    arrow.textContent = '→';
    link.append(arrow);
    return link;
  };

  const renderPredictiveResults = (payload, query) => {
    if (!searchResults) return;
    searchResults.replaceChildren();
    const results = payload?.resources?.results || {};
    const groups = [
      ['collections', 'Collections', 'Collection'],
      ['products', 'Produits', 'Produit'],
      ['pages', 'Pages', 'Page']
    ];
    let count = 0;

    groups.forEach(([key, heading, typeLabel]) => {
      const items = Array.isArray(results[key]) ? results[key].slice(0, 5) : [];
      if (!items.length) return;
      count += items.length;

      const group = document.createElement('section');
      group.className = 'fcc-header-search-group';

      const title = document.createElement('div');
      title.className = 'fcc-header-search-group__title';
      title.textContent = heading;
      group.appendChild(title);

      items.forEach((item) => group.appendChild(makeResultLink(item, typeLabel)));
      searchResults.appendChild(group);
    });

    if (!count) {
      const empty = document.createElement('p');
      empty.className = 'fcc-header-search__hint';
      empty.textContent = `Aucun résultat pour « ${query} ».`;
      searchResults.appendChild(empty);
      return;
    }

    const all = document.createElement('a');
    all.className = 'fcc-header-search__all';
    const root = window.Shopify?.routes?.root || '/';
    all.href = `${root}search?q=${encodeURIComponent(query)}&type=product%2Cpage%2Ccollection`;
    all.textContent = 'Voir tous les résultats →';
    searchResults.appendChild(all);
  };

  const loadPredictiveResults = async () => {
    if (!searchInput || !searchResults) return;
    const query = searchInput.value.trim();
    if (query.length < 2) {
      searchResults.innerHTML = '<p class="fcc-header-search__hint">Commencez à écrire pour afficher les résultats Shopify.</p>';
      return;
    }

    searchController?.abort();
    searchController = new AbortController();
    searchResults.innerHTML = '<p class="fcc-header-search__hint">Recherche en cours…</p>';

    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;

    try {
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        signal: searchController.signal
      });
      if (!response.ok) throw new Error('Recherche Shopify indisponible');
      const payload = await response.json();
      renderPredictiveResults(payload, query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      searchResults.innerHTML = '';
      const fallback = document.createElement('a');
      fallback.className = 'fcc-header-search__all';
      fallback.href = `${root}search?q=${encodeURIComponent(query)}&type=product%2Cpage%2Ccollection`;
      fallback.textContent = 'Afficher les résultats de recherche →';
      searchResults.appendChild(fallback);
    }
  };

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(loadPredictiveResults, 180);
  });

  /* ---------- FCCROCS V56 — guide pointure interactif longueur du pied ---------- */
  document.querySelectorAll('[data-fcc-foot-size-guide]').forEach((guide) => {
    const form = guide.closest('form');
    const opener = form?.querySelector('[data-fcc-foot-size-open]');
    const closers = [...guide.querySelectorAll('[data-fcc-foot-size-close]')];
    const lengthInput = guide.querySelector('[data-fcc-foot-length]');
    const lengthValue = guide.querySelector('[data-fcc-foot-length-value]');
    const sizeResult = guide.querySelector('[data-fcc-foot-size-result]');
    const resultCopy = guide.querySelector('[data-fcc-foot-size-copy]');
    const nextCopy = guide.querySelector('[data-fcc-foot-size-next]');
    const chooseButton = guide.querySelector('[data-fcc-foot-size-choose]');
    const status = guide.querySelector('[data-fcc-foot-size-status]');
    const variantSelect = form?.querySelector('[data-variant-select]');


    // FCCROCS V78 — onglets des tableaux de pointures Crocs adultes / enfants.
    const chart = guide.querySelector('[data-fcc-chart]');
    if (chart) {
      const chartTabs = [...chart.querySelectorAll('[data-fcc-chart-tab]')];
      const chartPanels = [...chart.querySelectorAll('[data-fcc-chart-panel]')];
      const changeChart = (key) => {
        chartTabs.forEach(tab => {
          const active = tab.dataset.fccChartTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        chartPanels.forEach(panel => { panel.hidden = panel.dataset.fccChartPanel !== key; });
      };
      chartTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => changeChart(tab.dataset.fccChartTab));
        tab.addEventListener('keydown', e => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          const next = chartTabs[(index + dir + chartTabs.length) % chartTabs.length];
          changeChart(next.dataset.fccChartTab);
          next.focus();
        });
      });
      // Les produits ayant une pointure enfant (inférieure à 36) ouvrent d'abord le tableau enfants.
      const hasKidsSizes = variantSelect && [...variantSelect.options].some(option => {
        const value = (option.dataset.fccOriginalSize || option.dataset.variantTitle || option.textContent || '').trim();
        const match = value.match(/\d{2}/);
        return match && Number(match[0]) < 36;
      });
      changeChart(hasKidsSizes ? 'enfant' : 'adulte');
    }

    const sizes = [
      { size:'25', inner:15.0 },
      { size:'26', inner:15.5 },
      { size:'27', inner:16.0 },
      { size:'28', inner:16.5 },
      { size:'29', inner:17.5 },
      { size:'30', inner:18.5 },
      { size:'31', inner:19.0 },
      { size:'32', inner:19.0 },
      { size:'33', inner:20.0 },
      { size:'34', inner:20.0 },
      { size:'35', inner:21.0 },
      { size:'36', inner:22.0 },
      { size:'37', inner:23.0 },
      { size:'38', inner:24.0 },
      { size:'39', inner:25.0 },
      { size:'40', inner:25.0 },
      { size:'41', inner:26.0 },
      { size:'42', inner:26.0 },
      { size:'43', inner:27.0 },
      { size:'44', inner:28.0 },
      { size:'45', inner:29.0 }
    ];

    const formatCm = (value) => Number(value).toFixed(1).replace('.', ',');
    const normalize = (value) => String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '')
      .replace(/pointure|taille|eu|eur/g, '');

    // V81 : recommander la plage EU de la taille habituelle (ex. 36 → EU 36–37)
    // et non la variante suivante (37 → EU 37–38).
    const getReco = (footLength) => {
      const index = sizes.findIndex((entry) => footLength <= entry.inner + 0.0001);
      const baseIndex = index === -1 ? sizes.length - 1 : index;
      return { base: sizes[baseIndex] };
    };

    const getEuLabel = (size, option) => {
      // Si Shopify possède déjà une vraie valeur EU, c'est elle qui fait foi.
      const title = String(option?.dataset?.variantTitle || '').trim();
      const range = title.match(/EU\s*(\d{2})\s*[–-]\s*(\d{2})/i);
      if (range) return `EU ${range[1]}–${range[2]}`;
      const number = Number(size);
      if (number === 25) return 'EU 24–25';
      if (number === 26) return 'EU 25–26';
      if (number >= 27 && number <= 45) return `EU ${number}–${number + 1}`;
      return `EU ${size}`;
    };

    const getSupplierSize = (option) => {
      const raw = String(option?.dataset?.fccOriginalSize || option?.dataset?.variantTitle || option?.textContent || '').trim();
      if (/^\d{2}$/.test(raw)) return raw;
      // Compatibilité avec les variantes historiques du CSV V79.
      const legacy = raw.match(/fournisseur\s*(\d{2})/i);
      if (legacy) return legacy[1];
      // Compatibilité avec les intitulés courts du nouveau CSV V80.
      const range = raw.match(/EU\s*(\d{2})\s*[–-]\s*(\d{2})/i);
      if (range) {
        const first = Number(range[1]);
        if (first === 24 && range[2] === '25') return '25';
        if (first === 25 && range[2] === '26') return '26';
        return String(first);
      }
      return '';
    };
    const findVariantOption = (size) => {
      if (!variantSelect) return null;
      return [...variantSelect.options].find(option => getSupplierSize(option) === String(size)) || null;
    };

    const updateGuide = () => {
      const footLength = Math.max(14, Math.min(29, Number(lengthInput?.value || 24)));
      const { base } = getReco(footLength);
      const cm = formatCm(footLength);
      // Le choix renvoie à la variante existante (36) même si le libellé affiché est EU 36–37.
      const option = findVariantOption(base.size);
      const euLabel = getEuLabel(base.size, option);
      if (lengthValue) lengthValue.textContent = cm;
      if (sizeResult) sizeResult.textContent = euLabel;
      if (resultCopy) {
        resultCopy.textContent = `Pour un pied de ${cm} cm, la mesure correspond à la taille ${base.size}. Si tu fais du ${base.size}, privilégie la taille ${euLabel}.`;
      }

      if (nextCopy) {
        nextCopy.textContent = `Si tu portes habituellement du ${base.size}, choisis ${euLabel} : privilégie toujours la pointure au-dessus.`;
      }

      if (chooseButton) {
        chooseButton.dataset.size = base.size;
        chooseButton.textContent = `Choisir ${euLabel}`;
        chooseButton.disabled = !option || option.disabled;
        if (!option) chooseButton.textContent = `${euLabel} non proposée sur ce produit`;
        else if (option.disabled) chooseButton.textContent = `${euLabel} indisponible`;
      }
      if (status) status.textContent = '';
    };

    const openGuide = () => {
      guide.hidden = false;
      document.body.classList.add('fcc-foot-size-lock');
      updateGuide();
      requestAnimationFrame(() => guide.classList.add('is-open'));
    };
    const closeGuide = () => {
      guide.classList.remove('is-open');
      document.body.classList.remove('fcc-foot-size-lock');
      window.setTimeout(() => { guide.hidden = true; }, 200);
    };

    lengthInput?.addEventListener('input', updateGuide);
    chooseButton?.addEventListener('click', () => {
      const size = chooseButton.dataset.size;
      const option = findVariantOption(size);
      const euLabel = getEuLabel(size, option);
      if (!variantSelect || !option) {
        if (status) status.textContent = `La pointure ${euLabel} n’est pas disponible sur ce produit.`;
        return;
      }
      if (option.disabled) {
        if (status) status.textContent = `La pointure ${euLabel} est actuellement indisponible.`;
        return;
      }
      variantSelect.value = option.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles:true }));
      if (status) status.textContent = `Pointure ${euLabel} sélectionnée ✓`;
      window.setTimeout(closeGuide, 350);
    });

    opener?.addEventListener('click', openGuide);
    closers.forEach((closer) => closer.addEventListener('click', closeGuide));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !guide.hidden) closeGuide();
    });
    updateGuide();
  });
});

/* ---------- FCCROCS V75 — changement de pointure panier : propriétés converties en Hash Shopify ---------- */
document.addEventListener('change', async (event) => {
  const select = event.target.closest('[data-fc-cart-variant-select]');
  if (!select || select.dataset.busy === 'true') return;

  const newVariantId = String(select.value || '').trim();
  const currentVariantId = String(select.dataset.currentVariantId || '').trim();
  if (!newVariantId || newVariantId === currentVariantId) return;

  const originalItemKey = String(select.dataset.itemKey || '').trim();
  const quantity = Math.max(1, parseInt(select.dataset.itemQuantity || '1', 10));
  const status = select.parentElement?.querySelector('[data-fc-cart-variant-status]');
  const propertiesScript = select.parentElement?.querySelector('[data-fc-cart-line-properties]');
  let properties = {};

  try {
    if (propertiesScript?.textContent?.trim()) properties = JSON.parse(propertiesScript.textContent);
  } catch (_) {
    properties = {};
  }

  // Liquid peut sérialiser item.properties comme un tableau de paires
  // ([['Nom','Valeur']]) alors que l'API Ajax Shopify exige un objet/hash.
  const propertiesToHash = (value) => {
    if (!value || typeof value !== 'object') return {};
    if (Array.isArray(value)) {
      return value.reduce((acc, entry) => {
        if (Array.isArray(entry) && entry.length >= 2 && entry[0] != null) {
          acc[String(entry[0])] = entry[1] == null ? '' : String(entry[1]);
        } else if (entry && typeof entry === 'object') {
          const key = entry.first ?? entry.name ?? entry.key;
          const val = entry.last ?? entry.value;
          if (key != null) acc[String(key)] = val == null ? '' : String(val);
        }
        return acc;
      }, {});
    }
    return Object.keys(value).reduce((acc, key) => {
      acc[String(key)] = value[key] == null ? '' : String(value[key]);
      return acc;
    }, {});
  };

  const normalizeProperties = (value) => {
    const hash = propertiesToHash(value);
    return Object.keys(hash).sort().reduce((acc, key) => {
      acc[key] = hash[key];
      return acc;
    }, {});
  };
  properties = normalizeProperties(properties);
  const sameProperties = (a, b) => JSON.stringify(normalizeProperties(a)) === JSON.stringify(normalizeProperties(b));
  const readError = async (response, fallback) => {
    try {
      const data = await response.json();
      return data?.description || data?.message || fallback;
    } catch (_) {
      return fallback;
    }
  };

  const root = window.Shopify?.routes?.root || '/';
  const oldValue = currentVariantId;
  let targetQuantityBefore = 0;
  let addedNewVariant = false;

  select.dataset.busy = 'true';
  select.disabled = true;
  if (status) status.textContent = 'Mise à jour…';
  document.querySelector('.fc-cart-page')?.classList.add('is-ajax-updating');

  try {
    // On lit d'abord le panier actuel afin de pouvoir revenir proprement en arrière si besoin.
    const beforeResponse = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!beforeResponse.ok) throw new Error('Impossible de lire le panier.');
    const beforeCart = await beforeResponse.json();

    const targetBefore = beforeCart.items?.find((item) =>
      String(item.variant_id) === newVariantId && sameProperties(item.properties || {}, properties)
    );
    targetQuantityBefore = Number(targetBefore?.quantity || 0);

    // Shopify ne permet pas de remplacer directement le variant d'une ligne via cart/change.js.
    // On ajoute donc la nouvelle pointure, puis on retire l'ancienne.
    const addResponse = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: newVariantId, quantity, properties }]
      })
    });
    if (!addResponse.ok) throw new Error(await readError(addResponse, 'La nouvelle pointure ne peut pas être ajoutée.'));
    addedNewVariant = true;

    // L'ajout d'une variante peut modifier les remises et donc changer la clé de ligne Shopify.
    // On recharge le panier pour récupérer la clé ACTUELLE de l'ancienne pointure avant de la retirer.
    const refreshedResponse = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!refreshedResponse.ok) throw new Error('Impossible de rafraîchir le panier.');
    const refreshedCart = await refreshedResponse.json();

    const oldItem = refreshedCart.items?.find((item) =>
      String(item.variant_id) === currentVariantId && sameProperties(item.properties || {}, properties)
    );
    const refreshedOldKey = String(oldItem?.key || originalItemKey || '').trim();
    if (!refreshedOldKey) throw new Error('Impossible de retrouver l’ancienne pointure dans le panier.');

    const removeResponse = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: refreshedOldKey, quantity: 0 })
    });
    if (!removeResponse.ok) throw new Error(await readError(removeResponse, 'L’ancienne pointure ne peut pas être retirée.'));

    if (status) status.textContent = 'Pointure modifiée ✓';
    window.location.reload();
  } catch (error) {
    console.error('[FCCROCS] Changement de pointure panier :', error);

    // Si la nouvelle pointure a été ajoutée mais que le retrait de l'ancienne a échoué,
    // on remet la quantité de la nouvelle variante à son état initial pour éviter un doublon.
    if (addedNewVariant) {
      try {
        const rollbackCartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (rollbackCartResponse.ok) {
          const rollbackCart = await rollbackCartResponse.json();
          const targetItem = rollbackCart.items?.find((item) =>
            String(item.variant_id) === newVariantId && sameProperties(item.properties || {}, properties)
          );
          if (targetItem?.key) {
            await fetch(`${root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: targetItem.key, quantity: targetQuantityBefore })
            });
          }
        }
      } catch (rollbackError) {
        console.error('[FCCROCS] Annulation du changement de pointure :', rollbackError);
      }
    }

    select.value = oldValue;
    select.disabled = false;
    select.dataset.busy = 'false';
    document.querySelector('.fc-cart-page')?.classList.remove('is-ajax-updating');
    if (status) status.textContent = error?.message || 'Impossible de modifier la pointure. Réessaie.';
  }
});
